import Vue from "vue";
import App from "./App.vue";
import AppApi from "./api.js";

Vue.config.productionTip = false;

Vue.use(AppApi);

new Vue({
  render: h => h(App)
}).$mount("#app");
